import { EventEmitter, Injectable, Output } from '@angular/core';
import { CvDto } from 'src/app/services/api-client/models';

@Injectable({
  providedIn: 'root'
})
export class ParseCvService {

  @Output() openSidebar = new EventEmitter<boolean>();
  @Output() parsedCv = new EventEmitter<CvDto>();

  constructor() { }

  openUploadSideBar() {
    this.openSidebar.emit(true);
  }

  closeUploadSideBar() {
    this.openSidebar.emit(false);
  }

  emitUploadedCv(cv: CvDto) {
    this.parsedCv.emit(cv);
  }
}
